import React from 'react'

const SocialActivity = () => (
  <React.Fragment>
    <p className="center mb2">Social activity</p>

    <div className="flex flex-center flex-column">
      <div
        className="bg-facebook mb-5"
        style={{ height: '40px', transform: 'skew(0, -15deg)', width: '40px' }}
      />

      <div
        className="bg-instagram mb-5"
        style={{ height: '15px', transform: 'skew(0, -15deg)', width: '15px' }}
      />

      <div
        className="bg-linkedin mb-5"
        style={{ height: '30px', transform: 'skew(0, -15deg)', width: '30px' }}
      />

      <div
        className="bg-twitter"
        style={{ height: '20px', transform: 'skew(0, -15deg)', width: '20px' }}
      />
    </div>
  </React.Fragment>
);

export default SocialActivity
